import Yup from '../validationsLib'

/**
 * Validations rules for login page
 */
export default Yup.object().shape({
    password: Yup.string()
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,32}$/,
            "Password should contains 8-32 characters. At least 1 digit, 1 special character, 1 uppercase letter & 1 lowercase letter."
        )
        .required("Password cannot be blank!"),
})
